import React, { useState, Fragment } from 'react';
import { isEmpty } from 'ramda';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import useScreen from 'hooks/useScreen';
import { TextField, Button, IconButton } from '@material-ui/core';
import Icon from 'sharedComponents/Icon';
import VideoUploader from 'sharedComponents/VideoUploader';

import useStyles from './useStyles';

const NewMessageField = ({ onMessageSend, isLoanOfficer }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [inputText, setInputText] = useState('');
  const { isDesktop } = useScreen();
  const [openVideoMessageSendPopup, setOpenVideoMessageSendPopup] = useState(false);
  const [videoFile, setVideoFile] = useState(null);

  const handleSendTextMessage = () => {
    if (isEmpty(inputText)) return;
    const message = { data: inputText, type: 'text' };
    onMessageSend(message);
    setInputText('');
  };

  const handleOnDrop = file => {
    const currentFile = file[0];
    setVideoFile(currentFile);
    setOpenVideoMessageSendPopup(true);
  };

  const handleTextInputChange = ({ target: { value } }) => {
    setInputText(value);
  };

  const closeVideoPopup = () => {
    setOpenVideoMessageSendPopup(false);
    setVideoFile(null);
  };

  const handleCloseVideoMessageSendPopup = () => {
    closeVideoPopup();
  };

  const handleSendVideoMessage = cachedVideo => {
    const message = { data: cachedVideo, type: 'video' };
    onMessageSend(message);
    closeVideoPopup();
  };

  const SendButton = isDesktop ? (
    <Button
      variant="contained"
      color="primary"
      className={classes.sendButton}
      startIcon={<Icon name="plane" />}
      onClick={handleSendTextMessage}
    >
      {t('components.Chat.sendMessageButtonText')}
    </Button>
  ) : (
    <IconButton onClick={handleSendTextMessage} className={classes.sendButton}>
      <Icon name="plane" />
    </IconButton>
  );

  return (
    <Fragment>
      <div className={classes.controlBar}>
        <TextField
          placeholder={t('components.Chat.inputFieldPlaceholder')}
          className={classes.inputField}
          onChange={handleTextInputChange}
          value={inputText}
          multiline
          maxRows="7"
          onKeyPress={e => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSendTextMessage();
            }
          }}
          inputProps={{
            style: {
              lineHeight: '21px',
            },
          }}
        />
        <div className={classes.controlButtons}>
          {isEmpty(inputText) ? (
            <Dropzone onDrop={handleOnDrop}>
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  {isLoanOfficer && (
                    <IconButton>
                      <Icon name="video" />
                    </IconButton>
                  )}
                </div>
              )}
            </Dropzone>
          ) : (
            SendButton
          )}
        </div>
      </div>
      {openVideoMessageSendPopup && (
        <VideoUploader
          onClose={handleCloseVideoMessageSendPopup}
          videoFile={videoFile}
          onSend={handleSendVideoMessage}
        />
      )}
    </Fragment>
  );
};

NewMessageField.propTypes = {
  onMessageSend: PropTypes.func.isRequired,
};

export default NewMessageField;



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/NewMessageField/NewMessageField.js